import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Components/Home/Home";
import Header from "./Components/Header/Header";
import About from "./Components/About"
import Projects from "./Components/Projects"
import Contact from "./Components/Contact"
import Blog from "./Components/Blog"
import Footer from "./Components/Footer";

const App = () =>{
  return(
    <BrowserRouter>
    <Header/>
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/dev/about" element={<About/>}/>
        <Route path="/dev/projects" element={<Projects/>}/>
        <Route path="/dev/contact" element={<Contact/>}/>
        <Route path="/dev/blog" element={<Blog/>}/>
      </Routes>
      <Footer/>
    </BrowserRouter>
  )
};

export default App;